import { render, staticRenderFns } from "./pointsrewardtype.vue?vue&type=template&id=51afd372&"
import script from "./pointsrewardtype.vue?vue&type=script&lang=js&"
export * from "./pointsrewardtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports